const colors = {
  mainYellow: "#F3A51C",
  mainBlue: "#140477",
  fadedBlue: "#F2F1F7",
};
export default colors;
